import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  Box,
  Button,
} from '@mui/material';
import { Pendingwarning } from 'component/BuyersMarketplace/MakeOffers';

const RedoWarning = ({
  open,
  onClose,
  heading,
  message,
  onConfirm,
  onCancel,
  address,
}) => {
  const handleCancel = () => {
    if (onCancel) onCancel();
    onClose();
  };

  const handleConfirm = () => {
    if (onConfirm) onConfirm();
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogContent sx={styles.dialogContent}>
        <Typography sx={styles.addressText}>{address}</Typography>

        <Box sx={styles.headerBox}>
          <Pendingwarning style={{ width: 22, height: 22 }} />
          <Typography sx={styles.headingText}>{heading}</Typography>
        </Box>

        <Typography sx={styles.messageText}>{message}</Typography>
      </DialogContent>

      <DialogActions sx={styles.dialogActions}>
        <Button
          variant="outlined"
          onClick={handleCancel}
          sx={styles.cancelButton}
        >
          Cancel
        </Button>

        <Button
          variant="contained"
          onClick={handleConfirm}
          sx={styles.confirmButton}
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RedoWarning;

const styles = {
  dialogContent: {
    padding: '24px 24px 16px 24px',
  },
  addressText: {
    fontSize: '13px',
    color: '#6B7280',
    fontFamily: 'Poppins',
    marginBottom: '24px',
  },
  headerBox: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    marginBottom: '16px',
  },
  headingText: {
    fontSize: '22px',
    fontWeight: 600,
    fontFamily: 'Poppins',
    color: '#111827',
  },
  messageText: {
    fontSize: '14px',
    color: '#6B7280',
    fontFamily: 'Poppins',
    marginTop: '12px',
  },
  dialogActions: {
    padding: '16px 24px 24px 24px',
    justifyContent: 'flex-end',
    gap: '12px',
  },
  cancelButton: {
    textTransform: 'none',
    fontFamily: 'Poppins',
    borderColor: '#D1D5DB',
    color: '#374151',
    '&:hover': {
      borderColor: '#9CA3AF',
      backgroundColor: '#F9FAFB',
    },
  },
  confirmButton: {
    textTransform: 'none',
    fontFamily: 'Poppins',
    backgroundColor: '#1976d2',
    '&:hover': {
      backgroundColor: '#1565c0',
    },
  },
};
